import React from 'react';
import { Reward } from '../types';

interface WorkingTowardProps {
  rewards: Reward[];
  selectedKidId: string;
  onNavigateToRewards?: () => void;
}

export const WorkingToward: React.FC<WorkingTowardProps> = ({
  rewards,
  selectedKidId,
  onNavigateToRewards,
}) => {
  // Filter rewards relevant to this kid (kid's own rewards + shared rewards)
  const relevantRewards = rewards.filter(
    (r) => r.is_shared === 1 || r.kid_id === selectedKidId
  );

  if (relevantRewards.length === 0) {
    return null;
  }

  return (
    <section className="working-toward-section">
      <h3 className="section-title">
        Working Toward 🎯
      </h3>

      <div className="compact-reward-list">
        {relevantRewards.map((reward) => {
          const progress = reward.stars_progress || 0;
          const cost = reward.star_cost;
          const percent = Math.min(100, Math.round((progress / cost) * 100));
          const remaining = reward.stars_remaining ?? Math.max(0, cost - progress);
          const isReady = remaining === 0;

          return (
            <div key={reward.id} className="compact-reward-card">
              <div className="compact-reward-header">
                <div className="compact-reward-left">
                  <span className="compact-reward-emoji">{reward.emoji}</span>
                  <span className="compact-reward-name">{reward.name}</span>
                </div>
                <span className={`compact-reward-status ${isReady ? 'ready' : ''}`}>
                  {isReady ? 'Ready! 🎉' : `${remaining}⭐ to go`}
                </span>
              </div>

              <div className="compact-reward-bar" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
                <div
                  className="compact-reward-fill"
                  style={{ width: `${percent}%` }}
                />
              </div>

              {isReady && (
                <div
                  className="compact-reward-ready-alert"
                  id={`alert-ready-${reward.id}`}
                  onClick={() => onNavigateToRewards?.()}
                  role="button"
                  tabIndex={0}
                  aria-label={`Visit Rewards tab to claim ${reward.name}`}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span>🎁</span>
                    <span>Ready to collect! Visit the Rewards tab to claim your award!</span>
                  </div>
                  <span className="compact-reward-ready-btn">Take Award →</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};
